import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
const LANGUAGE_STORAGE_KEY = 'selectedLanguage';

@Injectable({
  providedIn: 'root'
})
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  currentLanguage: string;
  constructor(private translate: TranslateService) {
    this.currentLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en';
    this.translate.setDefaultLang(this.currentLanguage);
    this.translate.use(this.currentLanguage);
    document.documentElement.setAttribute('dir', this.currentLanguage === 'ar' ? 'rtl' : 'ltr');
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    this.currentLanguage = lang; 
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
    // Apply directionality to the document
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
  }
  getCurrentLanguage(): string {
    return this.currentLanguage;
  }
}
